import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Pedidos extends Component {
    constructor(props){
        super(props);
   
        this.state = {
            pedidos: []
        }
   
   fetch('https://ebenlovequickpc.com/API/pedidos.php?cl=select')
       .then((response => response.json()))
       .then((json) => {
           this.setState({
               pedidos: json
           });
       });
    }
  render() {
    return (
        <div className="w3-container">
            <h5>Pedidos</h5>
            <table className="w3-table-all">
                <thead>
                    <tr className='w3-black'>
                        <th>Estado</th>
                        <th></th>
                        <th>Cliente</th>
                        
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                { this.state.pedidos.map((v, i) => {
                    return (
                    <tr key={i}>
                        {
                            (v.ESTADO == 'N') &&
                            <th><i className='fas fa-exclamation-triangle w3-text-amber w3-large'></i></th>
                        }
                        {
                            (v.ESTADO == 'C') &&
                            <th><i className='fas fa-check-circle w3-text-green w3-large'></i></th>
                        }
                        {
                            (v.ESTADO == 'R') &&
                            <th><i className='fas fa-times-circle w3-text-red w3-large'></i></th>
                        }
                        <td><i className="fa fa-user w3-text-blue w3-large"></i></td>
                        <td>{v.NOMBRE} {v.APELLIDOS}</td>
                        <td><Link to={`/pedidos/${v.CODIGO_FACTURA}`} className="w3-button w3-tiny  w3-border w3-round-large" style={{marginRight: '7px'}}>Ver</Link></td>
                    </tr>
                    )
                }) }
                </tbody>
            </table>
      </div>
    );
  }
}

export default Pedidos;


// WEBPACK FOOTER //
// ./src/Pedidos/Pedidos.js